import React from 'react';
import RootNavigation from './AppNavigator';
import {
  ReactEventDispatcher,
  AppKeyboardListener,
  ReactModalViewContextProvider,
  ReactModalView,
  isMobile,
} from '../app-components';
import { GpsContext } from '../withGpsContext';
import { gpsStore } from '../AppServices';
import Toast from '../app-components/toast/Toast';
import AppLoader from '../app-components/loader/AppLoader';
import AuthScreens from '../Auth';
import Unsubscribe from '../Unsubscribe';
import CustomerInterest from '../CustomerInterest';

export default () => {
  const visibleViews = isMobile ? 1 : 2;

  let { pathname } = typeof window !== undefined ? window.location : { pathname: '/' };
  const pathSegments = pathname.split('/');
  const pathSlit = pathSegments[1]


  return (
    <GpsContext.Provider value={gpsStore}>
      <ReactEventDispatcher>
        <AppKeyboardListener>
          <ReactModalViewContextProvider>
            {/* Render the Login component when the root path is accessed */}
            {window.location.pathname === '/' || window.location.pathname === '/login' ? (
              <AuthScreens.Login />
            ) : (pathSlit === 'unsubscribe' ? <Unsubscribe /> :
              pathSlit === 'customer-interest' ? <CustomerInterest /> :
                <RootNavigation visibleViews={visibleViews} />
            )}
            <ReactModalView />
            <AppLoader />
            <Toast />
          </ReactModalViewContextProvider>
        </AppKeyboardListener>
      </ReactEventDispatcher>
    </GpsContext.Provider>
  );
};
